/*
 * Module for the MemberDirect profile mfa page
*/

rs.module("content/user/profile/mfa",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(listApi) {

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {

                listApi.detail.updateTitle(context.DetailTitle)

                $.get(context.DetailUrl)
                    .done(function (html) {

                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {

                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);